import SessionEvent from 'session/SessionEvent.js';
import Tone from 'tone';
import {RESOLUTION_CHANGE} from 'session/constants.js';
import Resolution from 'engine/Resolution.js';

class ResolutionChangeEvent extends SessionEvent {
    constructor(resolution) {
        super();
        this.resolution = resolution;
    }

    getValue() {
        return this.resolution;
    }

    isDeterministic() {
        return true;
    }

    isSkippable() {
        return true;
    }

    executeEvent(sequencerEngine) {
    }

    getType() {
        return RESOLUTION_CHANGE;
    }

    getCopy() {
        let pattern = new ResolutionChangeEvent();
        pattern.fromJson(this.getJson());
        return pattern;
    }

    getJson() {
        return {
            ... super.getJson(),
            resolution: this.resolution.getJson(),
        };
    }

    fromJson(json, sequencerEngine) {
        super.fromJson(json);
        this.resolution = new Resolution();
        this.resolution.fromJson(json.resolution);
        return this;
    }

    isEquivalent(event) {
        return event.resolution.equals(this.resolution);
    }
}

export default ResolutionChangeEvent;

